import { Injectable } from '@angular/core';
import { UserGroup } from '@shared/interfaces';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserGroupService {
    private currentGroup: UserGroup = { id: '1', name: 'UX Team' };
    currentGroup$: Subject<UserGroup> = new Subject<UserGroup>();

    switchGroup(group: UserGroup): void {
        this.currentGroup = group;
        this.currentGroup$.next(group);
    }

    getCurrentGroup(): UserGroup {
        return this.currentGroup;
    }
}
